<template>
  <!-- 系統導覽列 -->
  <header class="system-layout">
    <nav class="navbar">
      <div class="nav-container">
        <!-- Logo 區域 -->
        <div class="logo">
          <router-link to="/">
            <img src="@/assets/image/leelogonew.svg" alt="Lee Logo" />
          </router-link>
          <!-- 酒店名稱 -->
          <div class="hotel-name">
            <span class="hotel-name">Lee.歐村</span>
            <span class="hotel-name-en">lee. ou tsun</span>
          </div>
        </div>

        <!-- 桌面版導覽選單（已改為寫死按鈕） -->
        <ul class="nav-menu" :class="{ 'nav-menu-active': isMobileMenuOpen }">
          <li class="nav-item">
            <router-link
              to="/"
              class="nav-link"
              :class="{ active: isActiveRoute('/') }"
              @click="closeMobileMenu"
            >
              HOME
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              to="/room"
              class="nav-link"
              :class="{ active: isActiveRoute('/room') }"
              @click="closeMobileMenu"
            >
              住宿資訊
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              to="/booking"
              class="nav-link"
              :class="{ active: isActiveRoute('/booking') }"
              @click="closeMobileMenu"
            >
              訂房須知
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              to="/travel"
              class="nav-link"
              :class="{ active: isActiveRoute('/travel') }"
              @click="closeMobileMenu"
            >
              旅遊地圖
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              to="/contact"
              class="nav-link"
              :class="{ active: isActiveRoute('/contact') }"
              @click="closeMobileMenu"
            >
              聯絡我們
            </router-link>
          </li>
        </ul>

        <!-- 手機版漢堡選單按鈕 -->
        <div class="nav-hamburger" @click="toggleMobileMenu">
          <span
            class="hamburger-line"
            :class="{ active: isMobileMenuOpen }"
          ></span>
          <span
            class="hamburger-line"
            :class="{ active: isMobileMenuOpen }"
          ></span>
          <span
            class="hamburger-line"
            :class="{ active: isMobileMenuOpen }"
          ></span>
        </div>
      </div>
    </nav>

    <!-- 手機版遮罩 -->
    <div
      class="mobile-overlay"
      :class="{ active: isMobileMenuOpen }"
      @click="closeMobileMenu"
    ></div>
  </header>

  <!-- 路由頁面渲染出口 -->
  <router-view />

  <!-- 頁尾 -->
  <footer class="footer" v-if="!route.meta.hideFooter">
    <div class="footer-container">
      <!-- 左側資訊 -->
      <div class="footer-info">
        <div class="footer-logo-container">
          <h3>Lee.歐村</h3>
        </div>
        <div class="footer-contact">
          <p>地址：高雄市左營區緯十一路31-1號</p>
          <p>FB：Lee.歐村民宿</p>
          <p>IG：lee.outsun</p>
          <p>LINE：@181onkjr</p>
        </div>
        <div class="social-icons">
          <a
            href="https://www.instagram.com/lee.outsun/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="fab fa-instagram"></i>
          </a>
          <a
            href="https://lin.ee/cClM96M"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="fab fa-line"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61584294556790"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="fab fa-facebook-f"></i>
          </a>
        </div>
      </div>

      <!-- 右側地圖 -->
      <div class="footer-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1547.6328273574054!2d120.29087878079916!3d22.694321869755782!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e05835f8caef5%3A0xc0665027a07556f6!2zODEz6auY6ZuE5biC5bem54ef5Y2A57ev5Y2B5LiA6LevMzHomZ8!5e0!3m2!1szh-TW!2stw!4v1754327124475!5m2!1szh-TW!2stw"
          width="100%"
          height="500"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
    <div class="footer-copyright">
      <p>Copyright © 2025 Lee.歐村 All Rights Reserved.</p>
      <p>Design by 彩虹小馬工作室</p>
    </div>
  </footer>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "App",
  setup() {
    const route = useRoute();
    const isMobileMenuOpen = ref(false);

    // 檢查當前路由是否為活動狀態
    const isActiveRoute = (path) => route.path === path;

    // 手機選單控制
    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value;
      document.body.style.overflow = isMobileMenuOpen.value ? "hidden" : "";
    };

    const closeMobileMenu = () => {
      isMobileMenuOpen.value = false;
      document.body.style.overflow = "";
    };

    // 監聽視窗大小變化，自動關閉手機選單
    const handleResize = () => {
      if (window.innerWidth > 1024 && isMobileMenuOpen.value) closeMobileMenu();
    };

    onMounted(() => window.addEventListener("resize", handleResize));
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
      document.body.style.overflow = "";
    });

    return {
      route,
      isMobileMenuOpen,
      isActiveRoute,
      toggleMobileMenu,
      closeMobileMenu,
    };
  },
};
</script>

<style scoped>
/* 導入外部樣式檔案 */
@import "@/assets/Css/styles.css";
</style>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  /* / 這是解決左右留白的最終手段 */
  overflow-x: hidden;
}
</style>
